module.exports = __webpack_public_path__ + "static/media/996483.a2250ced.png";